import { call, put, takeLatest } from 'redux-saga/effects';

import { BillingApi } from '@apis/BillingApi';
import { PaymentTransactionApi } from '@apis/PaymentTransactionApi';
import { Billing } from '@models/Billing';
import { PaymentTransaction } from '@models/PaymentTransaction';
import { SagaPayload } from '@utils/typescript';
import { PersonalAccidentQuoteApi } from '@apis/PersonalAccidentQuoteApi';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';

import {
  personalAccidentQuoteFetch,
  PersonalAccidentQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
  paymentTransactionCreate,
  PaymentTransactionCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handlePersonalAccidentQuoteFetch({ payload }: SagaPayload<PersonalAccidentQuoteFetchPayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.get, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleBillingFetch({ payload }: SagaPayload<BillingFetchPayload>) {
  const state: StateUpdatePayload = { billing: null };
  try {
    state.billing = (yield call(BillingApi.get, payload)) as Billing;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePaymentTransactionCreate({ payload }: SagaPayload<PaymentTransactionCreatePayload>) {
  const state: StateUpdatePayload = { paymentTransaction: null };
  try {
    state.paymentTransaction = (yield call(PaymentTransactionApi.create, payload)) as PaymentTransaction;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(personalAccidentQuoteFetch, handlePersonalAccidentQuoteFetch);
  yield takeLatest(billingFetch, handleBillingFetch);
  yield takeLatest(paymentTransactionCreate, handlePaymentTransactionCreate);
}
